// Obtiene la información serializada del producto enviada desde Liquid.
const productData = JSON.parse(
  document.getElementById("ProductData").textContent,
);

let pendingCartItem = null;




// Inicializa los eventos de la galería renderizada por Liquid.
bindGalleryEvents();

// Lista de variantes del producto.
const { variants } = productData;

// Las tres ranuras de opción que expone Shopify. El nombre de cada una lo
// define el producto: la ropa usa Color y Size, la botella usa Color,
// Capacity y Autographed. Por eso el selector trabaja por posición y nunca
// por nombre de opción.
const OPTION_KEYS = ["option1", "option2", "option3"];

/**
 * Devuelve las opciones de una variante como arreglo posicional.
 * Las ranuras que el producto no usa vienen en null.
 */
function readVariantOptions(variant) {
  return OPTION_KEYS.map((key) => variant[key] ?? null);
}

// Estado actual del selector, en el mismo orden posicional.
let selectedOptions = readVariantOptions(
  variants.find((variant) => variant.id === productData.currentVariantId) ??
    variants[0],
);

/**
 * Busca la variante que coincide exactamente con una combinación posicional.
 */
function findVariantByOptions(options) {
  return variants.find((variant) =>
    OPTION_KEYS.every((key, index) => (variant[key] ?? null) === options[index]),
  );
}

/**
 * Copia la combinación actual cambiando una sola opción.
 */
function withOption(index, value) {
  const next = selectedOptions.slice();

  next[index] = value;

  return next;
}

function isVariantInStock(variant) {
  return variant.available;
}

function isCombinationAvailable(options) {
  return findVariantByOptions(options)?.available ?? false;
}

/**
 * Busca la variante que coincide con la combinación actualmente seleccionada.
 */
function getCurrentVariant() {
  return findVariantByOptions(selectedOptions);
}

/**
 * Fija el valor elegido y acomoda el resto de las opciones a la primera
 * variante que exista con ese valor, prefiriendo una que tenga stock.
 * Sirve para que elegir un color cuya talla actual no existe no deje al
 * usuario trabado.
 */
function resolveCombination(index, value) {
  const candidates = variants.filter(
    (variant) => readVariantOptions(variant)[index] === value,
  );

  if (!candidates.length) return null;

  const match = candidates.find(isVariantInStock) ?? candidates[0];

  return readVariantOptions(match);
}

/**
 * Punto único de entrada para cualquier click en un selector de opción.
 */
function selectOptionValue(index, value) {
  let next = withOption(index, value);

  if (!findVariantByOptions(next)) {
    next = resolveCombination(index, value);
  }

  if (!next) return;

  selectedOptions = next;

  updateVariant();
}

/**
 * Sincroniza toda la información del producto
 * con la variante actualmente seleccionada.
 */
function updateVariant() {
  const variant = getCurrentVariant();

  // Las combinaciones inexistentes ya se resuelven en selectOptionValue,
  // así que acá sólo se corta si el producto no tiene variantes.

  if (!variant) return;

  updateColorButtons();
  updateOptionButtons();

  const inStock = isVariantInStock(variant);



  // Actualiza el id de la variante utilizado por el formulario.
  document.getElementById("VariantId").value = variant.id;

  // Actualiza el color mostrado en el título
  document.querySelectorAll(".SelectedColor").forEach((element) => {
    element.textContent = variant.option1;
  });

  // Actualiza el precio
  document.getElementById("ProductPrice").textContent = variant.price_formatted;

  // Actualiza el botón Add to Cart antes que la galería, para que un error
  // en las imágenes nunca deje el botón de la variante anterior.
  const addToCartButton = document.getElementById("AddToCartButton");

  if (inStock) {
    addToCartButton.disabled = false;
    addToCartButton.textContent =
      window.variantStrings?.addToCart || "Add to cart";
  } else {
    addToCartButton.disabled = true;
    addToCartButton.textContent =
      window.variantStrings?.soldOut || "Sold out";
  }

  showFormError("");

  // Actualiza la galería correspondiente a la variante.
  updateGallery(variant);

  // Actualiza wishlist con la variante actual
  const favoriteButton = document.querySelector(".favorite-btn");

  if (favoriteButton) {
    favoriteButton.dataset.variantId = variant.id;

    updateWishlistHeart(favoriteButton);
  }

  // console.log("Variante seleccionada", variant);
}

const favoriteButton = document.querySelector(".favorite-btn");

if (favoriteButton) {
  updateWishlistHeart(favoriteButton);

  favoriteButton.addEventListener("click", () => {
    const product = {
      productId: Number(favoriteButton.dataset.productId),

      variantId: Number(favoriteButton.dataset.variantId),

      handle: favoriteButton.dataset.productHandle,
    };

    App.wishlist.toggle(product);

    updateWishlistHeart(favoriteButton);
  });
}

// -----------------------------
// Selector de colores
// -----------------------------

// El color siempre es la primera opción y se dibuja como grilla de fotos.
const colorButtons = document.querySelectorAll(".color-option");

colorButtons.forEach((button) => {
  button.addEventListener("click", () => {
    if (button.disabled) return;

    selectOptionValue(0, button.dataset.color);
  });
});

// -----------------------------
// Selectores del resto de las opciones
// -----------------------------

// Un único manejador para Size, Capacity, Autographed o cualquier otra
// opción. Cada botón declara su posición en data-option-index.
const optionButtons = document.querySelectorAll(".size-option");

optionButtons.forEach((button) => {
  button.addEventListener("click", () => {
    if (button.disabled) return;

    selectOptionValue(Number(button.dataset.optionIndex), button.dataset.value);
  });
});

// -----------------------------
// Galería
// -----------------------------

const mainImage = document.getElementById("MainProductImage");
const thumbsContainer = document.getElementById("ProductGalleryThumbs");

/**
 * Sin galería propia, la variante usa su imagen destacada (o la del
 * producto) y las imágenes del producto, igual que el render de Liquid.
 */
function fallbackGallery(variant) {
  const images = productData.images || [];
  const featured = variant.featured_image;

  if (!featured) return images;

  return [
    { thumb: featured, large: featured },
    ...images.filter((image) => image.large !== featured),
  ];
}

/**
 * Reconstruye la galería de imágenes
 * según la variante seleccionada.
 */
function updateGallery(variant) {
  if (!mainImage || !thumbsContainer) return;

  const gallery = variant.gallery?.length
    ? variant.gallery
    : fallbackGallery(variant);

  // Un producto sin ninguna imagen no muestra una imagen rota.
  mainImage.hidden = !gallery.length;

  if (!gallery.length) {
    thumbsContainer.innerHTML = "";

    return;
  }

  // Actualiza la imagen principal.
  mainImage.src = gallery[0].large;
  mainImage.srcset = gallery[0].large;

  // Elimina las miniaturas anteriores.
  thumbsContainer.innerHTML = "";

  // Renderiza un máximo de 5 miniaturas.
  gallery.slice(0, 5).forEach((image, index) => {
    const button = document.createElement("button");

    button.type = "button";

    button.className = `
      product-gallery-thumb
      shrink-0
      overflow-hidden
      rounded-xl
      cursor-pointer
      border-2
      transition
      ${index === 0 ? "border-secondary-green" : "border-transparent"}
    `;

    button.dataset.imageUrl = image.large;

    const img = document.createElement("img");

    img.src = image.thumb;
    img.className = "h-30 w-30 object-cover";
    img.loading = "lazy";

    button.appendChild(img);

    thumbsContainer.appendChild(button);
  });

  // Las miniaturas fueron recreadas,
  // por lo que debemos volver a registrar sus eventos.
  bindGalleryEvents();
}

/**
 * Registra el evento click de las miniaturas
 * para actualizar la imagen principal.
 */
function bindGalleryEvents() {
  const thumbnails = document.querySelectorAll(".product-gallery-thumb");

  thumbnails.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      mainImage.src = thumb.dataset.imageUrl;
      mainImage.srcset = thumb.dataset.imageUrl;

      thumbnails.forEach((item) => {
        item.classList.remove("border-secondary-green");
        item.classList.add("border-transparent");
      });

      thumb.classList.remove("border-transparent");
      thumb.classList.add("border-secondary-green");
    });
  });
}

// -----------------------------
// UI Selectores
// -----------------------------

/**
 * Actualiza visualmente la grilla de colores.
 *
 * Un color se marca agotado sólo cuando ninguna de sus variantes tiene stock.
 * No se lo bloquea por la talla que esté elegida en ese momento, porque al
 * hacer click la talla se acomoda sola a una que exista para ese color.
 */
function updateColorButtons() {
  const selectedColor = selectedOptions[0];

  colorButtons.forEach((button) => {
    const color = button.dataset.color;

    const available = variants.some(
      (variant) => variant.option1 === color && isVariantInStock(variant),
    );

    const isActive = color === selectedColor;

    button.disabled = !available;

    button.classList.toggle("opacity-40", !available);
    button.classList.toggle("cursor-not-allowed", !available);
    button.classList.toggle("is-sold-out", !available);

    if (isActive) {
      button.classList.remove("border-transparent");
      button.classList.add("border-secondary-green");
    } else {
      button.classList.remove("border-secondary-green");
      button.classList.add("border-transparent");
    }
  });
}

/**
 * Actualiza visualmente el resto de los selectores de opción.
 *
 * Acá sí la disponibilidad es por combinación: una talla que no existe para
 * el color elegido se muestra agotada.
 */
function updateOptionButtons() {
  optionButtons.forEach((button) => {
    const index = Number(button.dataset.optionIndex);
    const value = button.dataset.value;

    const available = isCombinationAvailable(withOption(index, value));

    const isActive = selectedOptions[index] === value;

    button.disabled = !available;

    button.classList.toggle("opacity-40", !available);
    button.classList.toggle("cursor-not-allowed", !available);
    button.classList.toggle("is-sold-out", !available);
    button.classList.toggle("hover:text-white", available);
    button.classList.toggle("hover:bg-secondary-green", available);

    if (isActive) {
      button.classList.remove("bg-transparent", "text-secondary-green");

      button.classList.add("bg-secondary-green", "text-white");
    } else {
      button.classList.remove("bg-secondary-green", "text-white");

      button.classList.add("bg-transparent", "text-secondary-green");
    }
  });
}

// Pinta la disponibilidad inicial. Liquid ya dejó marcada la selección, pero
// el estado de agotado sólo lo conoce el JS.
updateColorButtons();
updateOptionButtons();

/**
 * Muestra (o limpia, con "") el mensaje debajo del botón Add to Cart.
 */
function showFormError(message) {
  const error = document.getElementById("ProductFormError");

  if (!error) return;

  error.textContent = message;
  error.classList.toggle("hidden", !message);
}

const form = document.getElementById("ProductForm");

form.addEventListener("submit", async (e) => {

    e.preventDefault();

    // Dawn's pattern: one request at a time, cleared in finally, so rapid
    // taps add exactly one unit.
    const button = document.getElementById("AddToCartButton");

    if (button.getAttribute("aria-disabled") === "true") return;

    const variant = getCurrentVariant();

    if (!variant) return;

    button.setAttribute("aria-disabled", "true");
    button.classList.add("loading");

    try {
        await addVariantToCart(
            variant.id
        );
    } catch (error) {
        // Cart errors are already shown in the cart pop-up. A 422 means this
        // variant can't be added any more (sold out, or all of it is already
        // in the cart), so mark it sold out and say why under the button.
        if (error.status === 422) {
            variant.available = false;

            updateVariant();

            showFormError(error.message);
        }

        if (error.status === undefined) console.error(error);
    } finally {
        button.classList.remove("loading");
        button.removeAttribute("aria-disabled");
    }

});